import { AxiosError } from "axios";
import { useMemo } from "react";
import useSWR from "swr";

import { userEndpoints } from "@api/Endpoints";
import { EssentialUser } from "@organization/models/EssentialUser";

import { fetcher } from "@utils/swrUtils";

export function useGetUserByEmail(email: string | null | undefined) {
  let url: null | string = null;

  if (email) {
    const params = new URLSearchParams();
    params.append("email", email);
    url = userEndpoints.getUserBy() + `?${params.toString()}`;
  }

  const { data, error, isLoading } = useSWR<EssentialUser, AxiosError>(
    url,
    fetcher
  );

  return useMemo(() => ({ data, isLoading, error }), [data, isLoading, error]);
}
